import React from 'react';

const MyinvHeader = ({ activeTab, myinvId, onTabChange }) => {
  const handleTabClick = (tab) => {
    if (onTabChange) {
      onTabChange(myinvId, tab);
    }
  };

  return (
    <div className="w-full px-1 py-3 border-b">
      <div className="w-full text-center bg-gray-800 text-white">
        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'investment' ? 'text-orange-500' : 'text-white'
          }`}
          onClick={() => handleTabClick('investment')}
        >
          Investment
        </button>
        <span className="mx-2">|</span>
        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'interest_payments' ? 'text-orange-500' : 'text-white'
          }`}
          onClick={() => handleTabClick('interest_payments')}
        >
          Interest & Payment
        </button>
        <span className="mx-2">|</span>
        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'myinv_register' ? 'text-orange-500' : 'text-white'
          }`}
          onClick={() => handleTabClick('myinv_register')}
        >
          Register
        </button>
        <span className="mx-2">|</span>
        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'myinv_loan_note' ? 'text-orange-500' : 'text-white'
          }`}
          onClick={() => handleTabClick('myinv_loan_note')}
        >
          Loan Note
        </button>
        <span className="mx-2">|</span>
        <button
          className={`px-2 py-1 font-bold text-sm ${
            activeTab === 'docs' ? 'text-orange-500' : 'text-white'
          }`}
          onClick={() => handleTabClick('docs')}
        >
          Documents
        </button>
      </div>
    </div>
  );
};

export default MyinvHeader;
